type ResolveConvexDeploymentInput = {
  storeDeployment?: string
  remoteConfigUrl?: string
  defaultUrl: string
}

function toConvexUrl(deployment: string) {
  const value = deployment.trim()
  return value.startsWith('http://') || value.startsWith('https://') ? value : `https://${value}.convex.cloud`
}

export function resolveConvexDeployment({
  storeDeployment,
  remoteConfigUrl,
  defaultUrl
}: ResolveConvexDeploymentInput) {
  if (storeDeployment?.trim()) {
    return {
      convexUrl: toConvexUrl(storeDeployment),
      source: 'store' as const
    }
  }

  if (remoteConfigUrl?.trim()) {
    return {
      convexUrl: remoteConfigUrl.trim(),
      source: 'feature-flags' as const
    }
  }

  return {
    convexUrl: defaultUrl,
    source: 'default' as const
  }
}
